import React, { Component } from "react";
import HeaderText from "page/HeaderText";
import Form from "page/Form";

import queryStringUtils from "utils/query-string";

export default class extends Component {
  onSubmit = ({ name, password }) => {
    const {
      postData,
      data: { role, company }
    } = this.props;

    const token = queryStringUtils.parse(window.location.search).token;
    const data = { name, password, role_slug: role.slug, company_id: company.id, token };
    postData(data);
  };
  render() {
    const { company, role, user } = this.props.data;
    const initialValues = { role: role.slug, email: user.email, name: user.name };
    return (
      <div>
        <HeaderText title={`${company.name} (${company.url})`} />
        <Form
          onSubmit={this.onSubmit}
          initialValues={initialValues}
          roleOptions={[{ label: role.name, value: role.slug }]}
          showPasswordField={user.passwordExists == 0}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/page/NonSuperuser/index.js